module.exports = __webpack_public_path__ + "assets/img/item1.369fe2bb.png";